import hash from 'object-hash';

import { ReportView } from 'pages/SbomAudit/constants';
import { ISbomData } from 'pages/SbomAudit/models/sbom-data';

export const Endpoint = () => `/api/pdf/sbom`;
export const QueryKey = (payload: Payload) =>
    ['pdf', 'sbom', hash(payload, { algorithm: 'md5', unorderedArrays: true })] as const;

export type Payload = {
    data: ISbomData;
    view: ReportView;
};

export type Response = Blob;
